export default "__VITE_ASSET__DzMzxTa3__"